<template>
  <div v-if="crumbs" class="breadcrumbs container">
    <nuxt-link to="/" class="home-breadcrumb">
      <BaseIcon icon="home"></BaseIcon>
    </nuxt-link>
    <BreadcrumbsItem
      v-for="breadcrumb in crumbs"
      :key="breadcrumb.to"
      :path="localePath(breadcrumb.to)"
    >
      {{ breadcrumb.text }}
    </BreadcrumbsItem>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();

type Breadcrumb = {
  to: string;
  text?: string;
};

const props = defineProps<{ breadcrumbs?: Breadcrumb[] }>();

const crumbs = computed<Breadcrumb[] | null>(() => {
  if (!props.breadcrumbs) {
    // If there is no crumb given, use current route and fetch a translated title
    const routeName = getRouteBaseName(router.resolve(route.fullPath));
    return routeName
      ? [{ to: routeName, text: t(`${routeName}.title`) }]
      : null;
  }

  // If crumbs are provided, fill missing text from translations
  return props.breadcrumbs.map((item) => ({
    to: item.to,
    text: item.text ?? t(`${item.to}.title`),
  }));
});

const route = useRoute();
const router = useRouter();
const getRouteBaseName = useRouteBaseName();
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;

  .home-breadcrumb {
    line-height: 1;
    color: $dark-100;
  }
}
</style>
